import {
  BlockScrollStrategy,
  Overlay,
} from "@angular/cdk/overlay";
import { NgModule } from "@angular/core";
import {
  MAT_AUTOCOMPLETE_SCROLL_STRATEGY,
  MatAutocompleteModule,
} from "@angular/material/autocomplete";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";

import { GlobalSearchComponent } from "#root/core/layout/common/global-search/global-search.component";
import { SharedModule } from "#root/shared/shared.module";

@NgModule({
  declarations: [GlobalSearchComponent],
  imports: [
    MatAutocompleteModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatProgressSpinnerModule,
    SharedModule,
  ],
  exports: [GlobalSearchComponent],
  providers: [
    {
      provide: MAT_AUTOCOMPLETE_SCROLL_STRATEGY,
      useFactory: (overlay: Overlay) => (): BlockScrollStrategy => overlay.scrollStrategies.block(),
      deps: [Overlay],
    },
  ],
})
export class GlobalSearchModule {}
